module.exports = __webpack_public_path__ + "img/UHE14deJulho2.9b3908c4.jpg";